import { API_URL } from '../../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject, 
    API_URL,
};

export const GET_DOMAIN_LIST_API = `${API_URL}/api/MasterDomains/GetMasterDomains`;
export const POST_DOMAIN_API = `${API_URL}/api/MasterDomains/SaveMasterDomain`;
export const GET_DOMAIN_DETAILS_API = `${API_URL}/api/MasterDomains/GetMasterDomainById`;
export const DELETE_DOMAIN_API = `${API_URL}/api/MasterDomains/DeleteMasterDomain`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const DomainActionTypes = {
  get_master_data: createRequestActionTypes('GET_TARGET_MASTER_DATA'),
  get_domainList: createRequestActionTypes('GET_DOMAINLIST'),
  post_domain: createRequestActionTypes('POST_DOMAIN'),
  get_domainDetails: createRequestActionTypes('GET_DOMAINDETAILS'),
  delete_domain: createRequestActionTypes('DELETE_DOMAIN'),
};

export const MODULE = 'DCMASTER_DOMAINS';





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/domain/constants/ApiConstants.js